<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section section-shaped my-0" style="background-image : url('img/theme/contact-me-001.png')">
                <div class="container shape-container d-flex align-items-center py-lg">
                    <div class="col px-0">
                        <div class="row align-items-center justify-content-center">
                            <div class="col-lg-6 text-center">
                                <h1 class="display-3  text-dark"> </h1>
                                
                        
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
            <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/ill/ill-2.svg" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <p>You can get in touch with me through any of the following mediums:</p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <icon name="ni ni-email-83" class="" size="lg" type="success" rounded></icon>
                                        
                                        <h6 class="ml-2">mails@raginisinha.in</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <icon name="ni ni-pin-3" class="" size="lg" type="danger" rounded></icon>
                                        
                                        <h6 class="ml-2">Delhi NCR, India</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
            <section class="section section-shaped my-0 overflow-hidden">
            <div class="container-fluid py-0">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <card gradient="secondary align-items-center contact-container" shadow body-classes="p-lg-5">
                            <iframe class="responsive-iframe" src="https://docs.google.com/forms/d/e/1FAIpQLSeJkU7DqqrMNaNi2byCAYva-I6tS8of6_gCiDZNsCw2--VEkg/viewform" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                            
                        </card>
                    </div>
                </div>
            </div>
        </section>
        </div>
    </div>
</template>

<script>
export default {
  name: "ContactUs",
  components: {}
};
</script>

<style scoped>
    .contact-container {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 1350px;
        padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
    }
    .responsive-iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }
</style>
